import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from 'shared/layout/Navbar';
import ThemeSettings from 'shared/layout/ThemeSettings';
import { FiSettings } from 'react-icons/fi';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { useLayout } from 'shared/contexts/LayoutContext';
import CenterModal from 'shared/ui/CenterModal';
import RightModal from 'shared/ui/RightModal';
import Tooltip from 'shared/ui/Tooltip';
import AuthenticationPage from 'features/auth/pages/Authentication';
import ErrorPage from 'app/ErrorPage';

const ModalContainer = () => {
  const { modals } = useLayout();

  return (
    <>
      {modals.map((modal, index) => {
        if(modal.type === 'right') {
          return <RightModal 
            key={modal.id}
            title={modal.title || `Modal ${index + 1}`}
            confirmCloseText={modal.confirmCloseText}
          >
            {modal.component}
          </RightModal> 
        } 
        else{
          return <CenterModal 
            key={modal.id}
            title={modal.title || `Modal ${index + 1}`}
            confirmCloseText={modal.confirmCloseText}
          >
            {modal.component}
          </CenterModal>  
        }
      })}
    </>
  );
};

const LoadingOverlay = ({ color }) => {
  return (
    <div className='fixed inset-0 z-[9999] flex items-center justify-center bg-black/20'>
      <div className='flex flex-col items-center gap-3'>
        <div 
          className='w-12 h-12 border-4 border-t-transparent rounded-full animate-spin'
          style={{ borderColor: `${color} transparent ${color} ${color}` }}
        />
        <span className='text-sm text-gray-600 font-medium'>Загрузка...</span>
      </div>
    </div>
  );
};


// const CenterModalContainer = () => {
//   const { centerModals, closeCenterModal } = useLayout();

//   return (
//     <>
//       {centerModals.map((modal, index) => (
//         <CenterModal 
//           key={modal.id}
//           title={modal.title || `Modal ${index + 1}`}
//           afterClose={() => closeCenterModal(modal.id)}
//         >
//           {modal.component}
//         </CenterModal>
//       ))}
//     </>
//   );
// };

const RootLayout = () => {
  const { currentMode, currentColor, themeSettings, setThemeSettings, token, user } = useStateContext();
  const { sidebarContent, setSidebarVisible, sidebarVisible, isLoading } = useLayout();
  

  if(token === null) return <AuthenticationPage/>;

  return (
    <div className={currentMode === 'Dark' ? 'dark' : ''}>
      <Navbar />

      <div className='flex flex-col relative dark:bg-main-dark-bg'>
        <div className='fixed right-4 bottom-4' style={{ zIndex: '1000' }}>
          <Tooltip content='Settings' position='Top'>
            <button
              type='button'
              onClick={() => setThemeSettings(true)}
              className='text-3xl text-white p-3 hover:drop-shadow-xl hover:bg-light-gray'
              style={{ background: currentColor, borderRadius: '50%' }}
            >
              <FiSettings />
            </button>
          </Tooltip>
        </div>

        <div className='bg-main-bg dark:bg-main-dark-bg w-full min-h-screen'>
          <ModalContainer />
          {isLoading && <LoadingOverlay color={currentColor} />}
          {themeSettings && <ThemeSettings/>}
          <div className='mt-32'>
            <div className='pt-10 bg-white dark:bg-gray-700 rounded-3xl'>
              <div className='flex flex-col md:flex-row w-full'>
                {/* Left Sidebar */}
                {sidebarVisible && (
                  <div className='w-full md:w-1/5 px-4 mb-4 md:mb-0'>
                    {sidebarContent}
                  </div>
                )} 
                {sidebarContent && (
                  <button className='w' onClick={()=>setSidebarVisible(!sidebarVisible)}>HIDE</button>
                )}


                {/* Main Content */}
                <div className={`${sidebarVisible ? 'w-full md:w-4/5' : 'w-full mx-auto max-w-screen-xl'}  bg-white dark:bg-gray-700`}>
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RootLayout;